<template>
  <span class="comps-audit-log-modal-table-title" v-text="title" />
</template>

<script>
import momentMixin from '@/mixins/moment.mixin';

export default {
  mixins: [momentMixin],

  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    title() {
      const userName = this.data?.UserName;
      const date = this.getDateInUserFormat(this.data?.TimeStamp);
      const time = this.getFormattedTime(this.data?.TimeStamp);

      return `${this.$t('auditLog.title.user')}: (${userName}) - ${date} - ${time}`;
    },
  },
};
</script>

<style scoped>
.comps-audit-log-modal-table-title {
  font-weight: 600;
}
</style>
